export const TRANSPARENCY_BREAKPOINT = 0.2;
//# sourceMappingURL=constants.js.map